/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import PaymentOrderService from "../../service/payment-order-service";
import { GridView, Griew, Column, Response, Filter } from "react-griew";
import Pasoonate from "pasoonate";
import CreatePaymentOrderWindow from "./CreatePaymentOrderWindow";
import EditPaymentOrderWindow from "./EditPaymentOrderWindow";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import PaymentWindow from "./PaymentWindow";
import TransferMoneyWindow from "./TransferMoneyWindow";
import ShowPaymentOrderWindow from "./ShowPaymentOrderWindow";

const paymentOrderService = new PaymentOrderService();
const griew = new Griew();

await loadDictionary('payment-order-main-page');

function PaymentOrderMainPage() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenCreateWindow, setIsOpenCreateWindow] = useState(false);
  const [isOpenEditWindow, setIsOpenEditWindow] = useState(false);
  const [isOpenShowWindow, setIsOpenShowWindow] = useState(false);
  const [isOpenPaymentWindow, setIsOpenPaymentWindow] = useState(false);
  const [isOpenTransferMoneyWindow, setIsOpenTransferMoneyWindow] = useState(false);
  const [selectedPaymentOrderId, setSelectedPaymentOrderId] = useState(null);
  const [paymentButtonState, setPaymentButtonState] = useState('disabled');
  const [selectedPaymentOrders, setSelectedPaymentOrders] = useState([]);
  const [activeTab, setActiveTab] = useState('all');

  const reloadList = () => { 
    setIsLoading(true);
    setSelectedPaymentOrders([]);
    griew.refresh();
  };

  const selectPaymentOrder = (element, order) => {
    if(element.checked) {
      setSelectedPaymentOrders(prev => [...prev, order]);
    } else {
      setSelectedPaymentOrders(prev => prev.filter(item => item.id !== order.id));
    }
  };

  const handleOpenCreateWindow = () => {
    setIsOpenCreateWindow(true);  
  };

  const handleCloseCreateWindow = () => {
    setIsOpenCreateWindow(false);
    reloadList();
  };

  const handleOpenEditWindow = (paymentOrderId) => {
    setSelectedPaymentOrderId(paymentOrderId);
    setIsOpenEditWindow(true);  
  };

  const handleCloseEditWindow = () => {
    setSelectedPaymentOrderId(null);
    setIsOpenEditWindow(false);
    reloadList();
  };

  const handleOpenShowWindow = (paymentOrderId) => {
    setSelectedPaymentOrderId(paymentOrderId);
    setIsOpenShowWindow(true);  
  };

  const handleCloseShowWindow = () => {
    setSelectedPaymentOrderId(null);
    setIsOpenShowWindow(false);  
  };

  const handleOpenPaymentWindow = () => {
    setIsOpenPaymentWindow(true);  
  };

  const handleClosePaymentWindow = () => {
    setIsOpenPaymentWindow(false);
    reloadList();
  };

  const handleOpenTransferMoneyWindow = () => {
    setIsOpenTransferMoneyWindow(true);  
  };

  const handleCloseTransferMoneyWindow = () => {
    setIsOpenTransferMoneyWindow(false);
    reloadList();
  };

  const handleRemovePaymentOrder = (id) => {
    paymentOrderService.findOne(id).then(paymentOrder => {
      if(paymentOrder && confirm(i18n.t("payment-order-main-page.remove_alert"))) {
        paymentOrderService.remove(paymentOrder).then(result => {
          if(result) {
            reloadList();
          }
        }).catch(error => {
          console.error(error);
        });
      }
    });    
  };

  useEffect(() => {
    prepareGriew(setCount, handleOpenEditWindow, handleOpenShowWindow, setIsLoading, selectedPaymentOrders, selectPaymentOrder, handleRemovePaymentOrder);
    reloadList();
  }, []);

  useEffect(() => {
    setPaymentButtonState(selectedPaymentOrders.length ? '' : 'disabled');
  }, [selectedPaymentOrders]);

  useEffect(() => {
    if(activeTab === 'all') {
      griew.filters.remove('is_locked');     
    } else {
      griew.filters.add('is_locked', Column.NUMBER, Filter.IS_EQUAL_TO, activeTab === 'lock' ? 1 : 0, null);
    }
    reloadList();
  }, [activeTab]);

  useEffect(() => {
    prepareGriew(setCount, handleOpenEditWindow, handleOpenShowWindow, setIsLoading, selectedPaymentOrders, selectPaymentOrder, handleRemovePaymentOrder);
    griew.render();
  }, [selectedPaymentOrders]);

  return (
    <div className="page">
      <div className="page-header bg-body p-3 pb-0">
        <h4 className="page-title pb-3">{i18n.t("payment-order-main-page.page_title")}</h4>
        <div className="header-content">
          <ul className="nav nav-underline">
            <li className="nav-item">
              <a href="#" className={"nav-link link-dark " + (activeTab === "all" ? "active" : "")} onClick={() => setActiveTab('all')} >{i18n.t("payment-order-main-page.all_tab")}</a>
            </li>
            <li className="nav-item">
              <a href="#" className={"nav-link link-dark " + (activeTab === "unlock" ? "active" : "")} onClick={() => setActiveTab('unlock')} >{i18n.t("payment-order-main-page.unlocked_tab")}</a>
            </li>
            <li className="nav-item">
              <a href="#" className={"nav-link link-dark " + (activeTab === "lock" ? "active" : "")} onClick={() => setActiveTab('lock')} >{i18n.t("payment-order-main-page.locked_tab")}</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="my-1">{i18n.t("payment-order-main-page.table_title")} {activeTab === "lock" ? i18n.t("payment-order-main-page.locked_tab") : activeTab === "unlock" ? i18n.t("payment-order-main-page.unlocked_tab") : ''} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className={"btn btn-sm btn-secondary mb-2 me-1"} type="button" onClick={handleOpenTransferMoneyWindow}>انتقال وجه</button>
            <button className={"btn btn-sm btn-secondary mb-2 me-1 " + paymentButtonState} type="button" onClick={() => {setSelectedPaymentOrders([])}}>{i18n.t("payment-order-main-page.clear_selections")}</button>
            <button className={"btn btn-sm btn-primary mb-2 me-1 " + paymentButtonState} type="button" onClick={handleOpenPaymentWindow}>{i18n.t("payment-order-main-page.payment_button")}</button>
            <button className="btn btn-sm btn-primary mb-2 me-1 " type="button" onClick={handleOpenCreateWindow}>{i18n.t("payment-order-main-page.new_button")}</button>
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="row mb-2">
          <div className="table-filter col"></div>
        </div>
        <div className="table-responsive">
          <GridView griew={griew} ></GridView>
        </div>
      </div>
      <CreatePaymentOrderWindow key={`create-${Date.now()}`} isOpenWindow={isOpenCreateWindow} onCloseWindow={handleCloseCreateWindow} />
      <EditPaymentOrderWindow key={`edit-${selectedPaymentOrderId}`} isOpenWindow={isOpenEditWindow} onCloseWindow={handleCloseEditWindow} paymentOrderId={selectedPaymentOrderId} /> 
      <ShowPaymentOrderWindow key={`show-${selectedPaymentOrderId}`} isOpenWindow={isOpenShowWindow} onCloseWindow={handleCloseShowWindow} paymentOrderId={selectedPaymentOrderId} />
      <PaymentWindow key={`payment-${selectedPaymentOrderId}`} isOpenWindow={isOpenPaymentWindow} onCloseWindow={handleClosePaymentWindow} paymentOrders={selectedPaymentOrders} />
      <TransferMoneyWindow key={`transfer-${Date.now()}`} isOpenWindow={isOpenTransferMoneyWindow} onCloseWindow={handleCloseTransferMoneyWindow} />
    </div>
  );
}

const prepareGriew = (setCount, handleOpenEditWindow, handleOpenShowWindow, setIsLoading, selectedPaymentOrders, selectPaymentOrder, handleRemovePaymentOrder) => {
  const list = [
    {
      name: "check",
      caption: "",
      schema: "PaymentOrder",
      type: Column.NUMBER,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, paymentOrder) => {
        const hasAccount = selectedPaymentOrders.find(item => item.id === paymentOrder.id) !== undefined;

        return <input type="checkbox" className="form-check-input" checked={hasAccount} disabled={paymentOrder.amount === null || paymentOrder.is_locked || paymentOrder.deleted_at} onChange={(e) => selectPaymentOrder(e.target, paymentOrder)}/>;
      }
    },  
    {
      name: "id",
      caption: "کد",
      schema: "َPaymentOrder",
      type: Column.NUMBER,
      order: 1,
      sortable: false,
      filterable: false,
      visibility: true,
    },
    {
      name: "party_id",
      caption: "طرف حساب",
      schema: "PaymentOrder",
      type: Column.STRING,
      order: 2,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, paymentOrder) => {
        return paymentOrder?.party?.name;
      }
    },
    {
      name: "party_bank_account_id",
      caption: "حساب بانکی مقصد",
      schema: "PaymentOrder",
      type: Column.STRING,
      order: 3,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, paymentOrder) => {
        return paymentOrder?.party_bank_account?.iban;
      }
    },
    {
      name: "amount",
      caption: "مبلغ",
      schema: "PaymentOrder",
      type: Column.STRING,
      order: 4,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => {
        return Number(value).toLocaleString();
      }
    },
    {
      name: "due_date",
      caption: "سررسید",
      schema: "PaymentOrder",
      type: Column.STRING,
      order: 5,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const dueDate = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
  
        return <span dir="ltr">{dueDate}</span>;
      },
    },
    {
      name: "created_at",
      caption: "تاریخ ایجاد",
      schema: "PaymentOrder",
      type: Column.DATETIME,
      order: 7,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const createdAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
  
        return <span dir="ltr">{createdAt}</span>;
      },
    },
    {
      name: "updated_at",
      caption: "تاریخ ویرایش",
      schema: "Party",
      type: Column.DATETIME,
      order: 8,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value) => { 
        const updatedAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
  
        return <span dir="ltr">{updatedAt}</span>;
      },
    },
    {
      name: "",
      caption: "عملیات",
      schema: "",
      type: Column.STRING,
      order: 9,
      sortable: false,
      filterable: false,
      visibility: true,
      beforeRender: (value, paymentOrder) => { 
        const showButton = <button type="button" className="btn btn-sm btn-light" onClick={() => { handleOpenShowWindow(paymentOrder.id) }}>{i18n.t("payment-order-main-page.show_button")}</button>;
        const editButton = (paymentOrder.deleted_at || paymentOrder.is_locked) ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleOpenEditWindow(paymentOrder.id) }}>{i18n.t("payment-order-main-page.edit_button")}</button>;
        const removeButton = (paymentOrder.deleted_at || paymentOrder.is_locked) ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleRemovePaymentOrder(paymentOrder.id) }}>{i18n.t("payment-order-main-page.remove_button")}</button>;

        return (
          <>
          {showButton}
          {editButton}          
          {removeButton}
          </>
        );
      }
    },
    {
      name: "is_locked",
      caption: "وضعیت",
      schema: "PaymentOrder",
      type: Column.NUMBER,
      order: 20,
      sortable: false,
      filterable: false,
      visibility: false
    }
  ];
  
  const callback = function (promis) {
    promis.then(response => {
      const pagination = response.pagination;
      const data = response.data;

      const res = Response.make({
        data: data,
        pagination: {
          currentPage: pagination?.currentPage ?? 1,
          lastPage: pagination?.lastPage ?? 1,
          perPage: pagination?.perPage ?? 15,
          total: pagination?.total ?? 1,
          from: pagination?.from ?? 1,
          to: pagination?.to ?? 1,
        }
      });

      griew.refresh(res);

      setCount(pagination.total);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
    });
  };
    
  griew.localization.locale = 'fa';
  griew.columns.fromArray(list);
  griew.providers.default = 'function';
  griew.providers.getProvider().options = {
    function: (query) => paymentOrderService.gridview(query),
    callback: callback
  };
};

export default PaymentOrderMainPage;